/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Bank_HolderInputs */

const vi_invoice_bank_holder = /** @type {(inputs: Invoice_Bank_HolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chủ tài khoản`)
};

/**

* @param {Invoice_Bank_HolderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_bank_holder = /** @type {((inputs?: Invoice_Bank_HolderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Bank_HolderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_bank_holder(inputs)
});